// extracted by mini-css-extract-plugin
export default {"container":"FilterSelect_container__uJQp9","label":"FilterSelect_label__z4mM0"};